export default __webpack_public_path__ + "static/17-0cd5c42d5e941156afd4bdce61e08a8e.jpg";